import apiClient from "../api/apiClient";   // ✅ ADD THIS LINE

export const getAttendanceReport = async (payload) => {
  const res = await apiClient.post("/attendance/report", payload);
  return res.data;
};
